import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "../components/Primitives";
import { api, errorText } from "../lib/api";

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await api.post("/auth/login", { email, password });
      onLogin(response.data.user);
      navigate("/dashboard");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-aside">
        <Logo dark />
        <div>
          <p className="hero-label">LIBRARYOS WORKSPACE</p>
          <h1>Run the day<br />with clarity.</h1>
          <p>Secure access for the people who keep every seat, shift and student moving.</p>
        </div>
        <span className="aside-note">Powered by MKS Digital Technology</span>
      </div>
      <div className="auth-main">
        <div className="auth-card">
          <button type="button" className="back-link" onClick={() => navigate("/")} data-testid="login-back-button">
            ← Back to overview
          </button>
          <div className="auth-heading">
            <p className="hero-label">WELCOME BACK</p>
            <h2>Sign in to LibraryOS</h2>
            <p>Use your workspace account to continue.</p>
          </div>
          <form onSubmit={submit} data-testid="login-form">
            <label htmlFor="login-email">Work email</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@library.com"
              required
              data-testid="login-email-input"
            />
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter your password"
              required
              data-testid="login-password-input"
            />
            {error ? (
              <div className="error-message" role="alert" data-testid="login-error-message">
                {error}
              </div>
            ) : null}
            <button className="button button-primary full-width" disabled={loading} type="submit" data-testid="login-submit-button">
              {loading ? "Checking access…" : "Sign in"}
              <ArrowRight size={17} />
            </button>
          </form>
          {process.env.NODE_ENV === "development" || process.env.REACT_APP_SHOW_DEMO_HINTS === "true" ? (
            <div className="demo-hint">
              <span>Demo access</span>
              <small>
                Main admin: <code>admin@libraryos.example</code> / <code>LibraryOSAdmin!2026</code>
                <br />
                Library admin: <code>admin@northblock.example</code> / <code>LibraryOSLibrary!2026</code>
              </small>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
